import { useQuery } from '@tanstack/react-query'

import { otherBessInputsLibraryClient } from '@/api'

export const useOtherBessInputsDatasetNames = () => {
  const { data } = useQuery({
    queryKey: [
      ...otherBessInputsLibraryClient.QUERY_KEY,
      { lockedOnly: false }
    ],
    queryFn: () => otherBessInputsLibraryClient.getAll()
  })

  return data?.map(x => x.name || '').filter(Boolean) || []
}
